import { render, staticRenderFns } from "./RolesScopeIndex.vue?vue&type=template&id=4060c8bb&scoped=true&"
import script from "./RolesScopeIndex.vue?vue&type=script&lang=js&"
export * from "./RolesScopeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4060c8bb",
  null
  
)

export default component.exports